module.exports = __webpack_public_path__ + "i18n/ja.4945b4e543117db50530c0a4b0a9f672.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1004
// module chunks = 60